import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { polyfill } from 'react-lifecycles-compat';
import createChainedFunction from 'rc-util/lib/createChainedFunction';
import KeyCode from 'rc-util/lib/KeyCode';
import placements from './picker/placements';
import Trigger from 'rc-trigger';
import { prefix } from "../../../wui-core/src/index.js";

function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker = /*#__PURE__*/function (_React$Component) {
  _inherits(Picker, _React$Component);

  var _super = _createSuper(Picker);

  function Picker(_props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "onCalendarKeyDown", function (event) {
      if (event.keyCode === KeyCode.ESC || event.keyCode === KeyCode.TAB) {
        event.stopPropagation();
        event.target._dataTransfer = {
          owner: ReactDOM.findDOMNode(_this.outInput),
          _target: e.target
        };

        _this.close(_this.focus);
      }

      _this.props.onKeyDown && _this.props.onKeyDown(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onCalendarSelect", function (value) {
      var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var isRangePicker = arguments.length > 2 ? arguments[2] : undefined;
      var props = _this.props;
      var isDisabled = props.disabledDate && props.disabledDate(value);
      var idYearDisabled = props.disabledYear && props.disabledYear(value);
      if (isDisabled || idYearDisabled) return;

      if (!('value' in props)) {
        _this.setState({
          value: value
        });
      }

      if (cause.source === 'keyboard' || cause.source === 'dateInputSelect' || !props.calendar.props.timePicker && cause.source !== 'dateInput' || cause.source === 'todayButton') {
        _this.close(_this.focus);
      }

      if (!isRangePicker) {
        props.onChange(value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      // formcontrol onKeyDown
      var enterKeyDown = _this.props.enterKeyDown;

      if (event.keyCode === KeyCode.DOWN || enterKeyDown && event.keyCode === KeyCode.ENTER) {
        if (!_this.state.open) {
          _this.open();

          event.nativeEvent.stopImmediatePropagation(); // event.target._dataTransfer = {
          //   owner: e
          // }
        }

        event.preventDefault();
        event.stopPropagation(); // delete event.keyCode;
      } else if (event.keyCode === KeyCode.TAB) {
        if (_this.state.open) {
          _this.close();

          _this.focus();

          event.preventDefault();
          event.stopPropagation();
        }
      } else {
        event.target._dataTransfer = {
          open: _this.state.open,
          owner: event.target,
          _target: event.target,
          ownerIsTarget: true
        };
      }

      _this.props.onKeyDown && _this.props.onKeyDown(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onCalendarOk", function () {
      _this.close(_this.focus);
    });

    _defineProperty(_assertThisInitialized(_this), "onCalendarClear", function () {
      _this.close(_this.focus);
    });

    _defineProperty(_assertThisInitialized(_this), "onVisibleChange", function (open) {
      _this.setOpen(open);
    });

    _defineProperty(_assertThisInitialized(_this), "getCalendarElement", function () {
      var props = _this.props;
      var state = _this.state;
      var calendarProps = props.calendar.props;
      var value = state.value;
      var defaultValue = value;
      var extraProps = {
        ref: _this.saveCalendarRef,
        defaultValue: defaultValue || calendarProps.defaultValue,
        selectedValue: value,
        onKeyDown: _this.onCalendarKeyDown,
        onOk: createChainedFunction(calendarProps.onOk, _this.onCalendarOk),
        onSelect: createChainedFunction(calendarProps.onSelect, _this.onCalendarSelect),
        onClear: createChainedFunction(calendarProps.onClear, _this.onCalendarClear)
      };
      return /*#__PURE__*/React.cloneElement(props.calendar, extraProps);
    });

    _defineProperty(_assertThisInitialized(_this), "setOpen", function (open, callback) {
      var onOpenChange = _this.props.onOpenChange;

      if (_this.state.open !== open) {
        if (!('open' in _this.props)) {
          _this.setState({
            open: open
          }, callback);
        }

        onOpenChange(open);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "open", function (callback) {
      _this.setOpen(true, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "close", function (callback) {
      _this.setOpen(false, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      if (!_this.state.open) {
        ReactDOM.findDOMNode(_assertThisInitialized(_this)).focus();
      } // } else {
      //   // ReactDOM.findDOMNode(this).focus();
      //   if(this.calendarInstance)
      //     this.calendarInstance.focus();
      // }

    });

    _defineProperty(_assertThisInitialized(_this), "focusCalendar", function () {
      if (_this.state.open && !!_this.calendarInstance) {
        _this.calendarInstance.focus();
      }
    });

    var _open;

    if ('open' in _props) {
      _open = _props.open;
    } else {
      _open = _props.defaultOpen;
    }

    var _value = _props.value || _props.defaultValue;

    _this.saveCalendarRef = refFn.bind(_assertThisInitialized(_this), 'calendarInstance');
    _this.state = {
      open: _open,
      value: _value
    };
    return _this;
  }

  _createClass(Picker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!prevState.open && this.state.open) {
        // setTimeout is for making sure saveCalendarRef happen before focusCalendar
        this.focusTimeout = setTimeout(this.focusCalendar, 0, this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.focusTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var prefixCls = props.prefixCls,
          placement = props.placement,
          style = props.style,
          getPopupContainer = props.getPopupContainer,
          align = props.align,
          animation = props.animation,
          disabled = props.disabled,
          dropdownClassName = props.dropdownClassName,
          transitionName = props.transitionName,
          children = props.children;
      var state = this.state;
      return /*#__PURE__*/React.createElement(Trigger, {
        popup: this.getCalendarElement(),
        popupAlign: align,
        builtinPlacements: placements,
        popupPlacement: placement,
        action: disabled && !state.open ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getPopupContainer,
        popupStyle: style,
        popupAnimation: animation,
        popupTransitionName: transitionName,
        popupVisible: state.open,
        onPopupVisibleChange: this.onVisibleChange,
        prefixCls: prefixCls,
        popupClassName: dropdownClassName
      }, /*#__PURE__*/React.cloneElement(children(state, props), {
        onKeyDown: this.onKeyDown
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var newState = {};
      var value = nextProps.value,
          open = nextProps.open;

      if ('value' in nextProps) {
        newState.value = value;
      }

      if (open !== undefined) {
        newState.open = open;
      }

      return newState;
    }
  }]);

  return Picker;
}(React.Component);

_defineProperty(Picker, "propTypes", {
  animation: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  disabled: PropTypes.bool,
  transitionName: PropTypes.string,
  onChange: PropTypes.func,
  onOpenChange: PropTypes.func,
  children: PropTypes.func,
  getPopupContainer: PropTypes.func,
  calendar: PropTypes.element,
  style: PropTypes.object,
  open: PropTypes.bool,
  defaultOpen: PropTypes.bool,
  prefixCls: PropTypes.string,
  placement: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  align: PropTypes.object,
  enterKeyDown: PropTypes.bool //enter 键是否打开日期面板

});

_defineProperty(Picker, "defaultProps", {
  prefixCls: "".concat(prefix, "-date-calendar-picker"),
  style: {},
  align: {},
  placement: 'bottomLeft',
  defaultOpen: false,
  onChange: noop,
  onOpenChange: noop,
  enterKeyDown: true
});

polyfill(Picker);
export default Picker;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/Picker.js